import { CREATE_EMAIL, CREATE_EMAIL_STATUS, CREATE_PASSWORD, CREATE_PASSWORD_STATUS, CREATE_PHONE, CREATE_PHONE_STATUS } from '../types';

export function createPhone(phone) {
    return {
        type: CREATE_PHONE,
        payload: phone
    };
}
export function createEmail(email) {
    return {
        type: CREATE_EMAIL,
        payload: email
    };
}
export function createPassword(password) {
    return {
        type: CREATE_PASSWORD,
        payload: password
    };
}

export function createPhoneStatus(validation) {
    return {
        type: CREATE_PHONE_STATUS,
        payload: validation
    };
}
export function createEmailStatus(validation) {
    return {
        type: CREATE_EMAIL_STATUS,
        payload: validation
    };
}
export function createPasswordStatus(validation) {
    return {
        type: CREATE_PASSWORD_STATUS,
        payload: validation
    };
}